import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { PriceFilteringRuleAction } from '@cbridge-packages/price-filtering-rules';
import { RulesManagementAction, makeRuleRowModelAndState } from '@cbridge-modules/rules-management-page';

export const onLoadPriceFilteringRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(
    PriceFilteringRuleAction.loadList.done,
  ),
  mergeMap((payload) => {
    const { rows, initialState } = makeRuleRowModelAndState(payload.result);
    return [
      RulesManagementAction.updateState({ ...initialState, rules: rows }),
    ];
  }),
);
